import React from 'react';

export const GrainOverlay = () => (
  <div className="grain-overlay" data-testid="grain-overlay" aria-hidden="true" />
);

export default GrainOverlay;
